import { render } from "./CardContatos.vue?vue&type=template&id=4d1a40c8"
import script from "./CardContatos.vue?vue&type=script&lang=js"
export * from "./CardContatos.vue?vue&type=script&lang=js"

import "./CardContatos.vue?vue&type=style&index=0&id=4d1a40c8&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__